class ScrollVideo extends HTMLElement {
    constructor(){
        super();
        this.filmFeatures = this.querySelectorAll('.film-feature-sc');
        this.activated = false;
        window.addEventListener("scroll", () => {
            this.filmFeatures.forEach(filmFeature => {
                this.filmContentDesktop = filmFeature.querySelector("#filmContentDesktop");
                this.contentDesktop = this.filmContentDesktop.querySelector(".js-content-desktop");
                this.filmContentMobile = filmFeature.querySelector("#filmContentMobile");
                this.contentMobile = this.filmContentMobile.querySelector(".js-content-mobile");
                if(pageYOffset >= filmFeature.offsetTop - 500 && this.activated === false) {
                    filmFeature.classList.add("active");
                    this.contentDesktop.classList.add('animated', 'fadeInUp');
                    this.contentMobile.classList.add('animated', 'fadeInUp');
                    this.activated = true;
                } else if(pageYOffset < filmFeature.offsetTop - 500 && this.activated === true) {
                    filmFeature.classList.remove("active");
                    this.contentDesktop.classList.remove('animated', 'fadeInUp');
                    this.contentMobile.classList.remove('animated', 'fadeInUp');
                    this.activated = false;
                }
            });
        });
    }
}
customElements.define("scroll-video", ScrollVideo);
